import React, { CSSProperties, FC } from 'react';
import { useTheme } from '../../../../hooks/useTheme';
import paths from './paths';
import styles from './QuestionMark.module.css';

export interface QuestionMarkIconProps {
  containerCustomStyle?: CSSProperties;
  // componentThemeOverrides from helpPill
  styleIconOverrides?: CSSProperties;
}

const QuestionMarkIcon: FC<QuestionMarkIconProps> = ({
  containerCustomStyle,
  styleIconOverrides,
}) => {
  const { iconsPrimaryNone: questionMarkIconStyle } = useTheme();
  const style = {
    ...(styleIconOverrides ?? questionMarkIconStyle),
    ...containerCustomStyle,
  };

  return (
    <svg
      className={styles.container}
      style={{ fill: style.color, ...style }}
      aria-hidden="true"
      role="img"
      aria-label="Question mark icon"
      viewBox="0 0 48 48"
    >
      <path d={paths} />
    </svg>
  );
};

export default QuestionMarkIcon;
